class AuthUser {
  public constructor(public authKey: string, public name: string) {
  }
}

export default AuthUser;
